import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Global from 'models/Global';
import JoinView from 'views/JoinView';
import authTemplate from 'hbars!templates/auth';
import SignUpView from 'views/SignUpView';
import PrivateCommunityView from 'views/PrivateCommunityView';
import FeatureToggleUtils from 'FeatureToggleUtils';
import { isBizzaboInternalWebsiteWhiteLabeled } from '@bizzabo/whitelabel-utils';

const isCrossOriginIsolatedWhitelabel = (event) =>
    window.crossOriginIsolated && isBizzaboInternalWebsiteWhiteLabeled(event.toJSON());


var AuthView = Backbone.View.extend({
    initialize: function() {
        this.subViews = [];
        this.me = Global.get('me');
        this.event = Global.get('event');
        FeatureToggleUtils.mergeFeatureToggleWithConfig();

        const isPeopleV2Community = this.event?.get('features')?.communityVersion === 'PEOPLE_V2';
        if (isPeopleV2Community) {
            return;
        }

        this.listenTo(this.me, 'change:isJoined', this.isJoinedChanged);

        this.joinView = new JoinView({
            el: this.$('.auth-view-box-join-view'),
            model: this.me,
            event: this.event
        });
        this.subViews.push(this.joinView);
        this.listenTo(this.joinView, 'private-community', this.addPrivateCommunityView);

        if (this.me.get('status') === 'generated') {
            if (this.me.noJoin || isCrossOriginIsolatedWhitelabel(this.event)) {
                this.quit();
            } else {
                this.me.set('isVerified', false);
                this.addSignUpView();
            }
        } else if (this.me.noJoin) {
            this.quit();
        }
    },

    remove: function() {
        _.each(this.subViews, function(view) {
            view.remove();
        });
        return Backbone.View.prototype.remove.call(this);
    },

    isJoinedChanged: function() {
        var isJoined = this.me.get('isJoined');

        if (isJoined) {
            this.quit();
        } else {
            this.showUp();
        }
    },

    quit: function() {
        Backbone.trigger('set-scrolling', true);
        this.remove();
    },

    showUp: function() {
        Backbone.trigger('set-scrolling', false);
    },

    pushView: function(view) {
        this.subViews = this.subViews || [];
        var topView = _.last(this.subViews);
        topView && topView.$el.show(0).slideUp(0);
        this.subViews.push(view);
        this.$('.auth-view-box').append(view.render().$el);
        view.$el.hide().slideDown(0);
        this.listenTo(view, 'back', this.popView);
        this.listenTo(view, 'next', this.pushView);
        this.listenTo(view, 'private-community', this.addPrivateCommunityView);
        this.renderStepIndicator();
    },

    popView: function() {
        var thisView = this;
        this.subViews = this.subViews || [];
        var poppedView = this.subViews.pop();
        var topView = _.last(this.subViews);
        poppedView && poppedView.$el.slideUp('fast', function() {
            thisView.stopListening(poppedView);
            poppedView.remove();
        });
        topView && topView.$el.hide().slideDown();
        this.renderStepIndicator();
        return poppedView;
    },

    addSignUpView: function() {
        const signUpView = new SignUpView({
            model: this.me,
            event: this.event
        });
        this.pushView(signUpView);
    },

    addPrivateCommunityView: function() {
        var thisView = this;
        var privateCommunityView = new PrivateCommunityView({
            model: thisView.me,
            event: thisView.event
        });
        thisView.pushView(privateCommunityView);
    },

    renderStepIndicator: function() {
        var step = (this.subViews.length - 1);
        if (!this.subViews[step].shouldShowStepIndicator) {
            step = -1;
        }

        this.$('.auth-view-box-steps').toggle(step > 0);
        this.$('.auth-view-box-step.selected').removeClass('selected');
        if (step > 0) {
            var selectedElement = $(this.$('.auth-view-box-step')[step - 1]);
            selectedElement.addClass('selected');
        }
    },

    render: function() {
        var html = authTemplate({
            me: this.me.toJSON(),
            event: this.event.toJSON()
        });
        this.$el.html(html);
        this.joinView.setElement(this.$('.auth-view-box-join-view'));
        Backbone.trigger('set-scrolling', this.me.get('isJoined'));
        return this;
    }
});

export default AuthView;


